import { RolesSearchInterface } from "../interface/searchInterface";

export const searchInit : RolesSearchInterface = {
    keywordType : '0',
    keyword : '',
    limit : 10,
    pageNo : 1,
    dutyGroupId : 0,
    usePagination : true

}